function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 221,
  height: 279,
  fill: "#E8EEFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 221,
  height: 279,
  stroke: "#CDDBFE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M175 49L175 144V155.25V165",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47 52V76L47 92H79L79 124H47V135.25L47 146.5",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M111 52V72V92H79L79 124H111V135.25L111 146.5",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "8 8"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 48,
  r: 24,
  fill: "#D9D9D9"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 48,
  r: 24,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 64,
  r: 16,
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 44,
  r: 8,
  fill: "#E8EEFD"
})));

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 48,
  r: 24,
  fill: "#D9D9D9"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 48,
  r: 24,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 64,
  r: 16,
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 44,
  r: 8,
  fill: "#E8EEFD"
})));

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 48,
  r: 24,
  fill: "#D9D9D9"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 48,
  r: 24,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 56,
  r: 16,
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 36,
  r: 8,
  fill: "#E8EEFD"
})), /*#__PURE__*/React.createElement("path", {
  d: "M155 49C155 48.4477 155.448 48 156 48H194C194.552 48 195 48.4477 195 49V72H155V49Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("rect", {
  x: 159,
  y: 54,
  width: 32,
  height: 2,
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 159,
  y: 62,
  width: 32,
  height: 2,
  fill: "#9FB4F9"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M111 190V198V224",
  stroke: "white",
  strokeWidth: 4
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M47 190V198V224",
  stroke: "white",
  strokeWidth: 4
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_d_4983_80110)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 144,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 157C33 156.448 33.4477 156 34 156H42.382C42.7607 156 43.107 156.214 43.2764 156.553L45 160H33V157Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_d_4983_80110)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 160H59C60.1046 160 61 160.895 61 162V178C61 179.105 60.1046 180 59 180H35C33.8954 180 33 179.105 33 178V160Z",
  fill: "#E8EEFD"
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_d_4983_80110)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 144,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97 157C97 156.448 97.4477 156 98 156H106.382C106.761 156 107.107 156.214 107.276 156.553L109 160H97V157Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_d_4983_80110)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M97 160H123C124.105 160 125 160.895 125 162V178C125 179.105 124.105 180 123 180H99C97.8954 180 97 179.105 97 178V160Z",
  fill: "#E8EEFD"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_d_4983_80110)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 208,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#9FB4F9",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 221C33 220.448 33.4477 220 34 220H42.382C42.7607 220 43.107 220.214 43.2764 220.553L45 224H33V221Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_d_4983_80110)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 224H59C60.1046 224 61 224.895 61 226V242C61 243.105 60.1046 244 59 244H35C33.8954 244 33 243.105 33 242V224Z",
  fill: "#E8EEFD"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_d_4983_80110)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 208,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 224,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 224,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 240,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 240,
  r: 4,
  fill: "#F6E8FE"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_d_4983_80110)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 150,
  y: 144,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 160,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 160,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 176,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 176,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 176,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_d_4983_80110)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 176,
  r: 4,
  fill: "#F6E8FE"
})));

var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4983_80110",
  x: 11,
  y: 20,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_4983_80110",
  x: 27,
  y: 32,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_4983_80110",
  x: 75,
  y: 20,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_4983_80110",
  x: 91,
  y: 32,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d_4983_80110",
  x: 139,
  y: 20,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_d_4983_80110",
  x: 155,
  y: 24,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_d_4983_80110",
  x: 11,
  y: 140,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_d_4983_80110",
  x: 21,
  y: 148,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_d_4983_80110",
  x: 75,
  y: 140,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_d_4983_80110",
  x: 85,
  y: 148,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_d_4983_80110",
  x: 11,
  y: 204,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_d_4983_80110",
  x: 21,
  y: 212,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_d_4983_80110",
  x: 75,
  y: 204,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_d_4983_80110",
  x: 97,
  y: 212,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_d_4983_80110",
  x: 99,
  y: 214,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_d_4983_80110",
  x: 89,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_d_4983_80110",
  x: 91,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_d_4983_80110",
  x: 105,
  y: 228,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_d_4983_80110",
  x: 107,
  y: 230,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_d_4983_80110",
  x: 138,
  y: 140,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_d_4983_80110",
  x: 160,
  y: 148,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_d_4983_80110",
  x: 162,
  y: 150,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_d_4983_80110",
  x: 152,
  y: 164,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_d_4983_80110",
  x: 154,
  y: 166,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_d_4983_80110",
  x: 168,
  y: 164,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_d_4983_80110",
  x: 170,
  y: 166,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80110"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80110",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4983_80110"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 24,
  width: 48,
  height: 48,
  rx: 24,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_4983_80110"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 24,
  width: 48,
  height: 48,
  rx: 24,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_4983_80110"
}, /*#__PURE__*/React.createElement("rect", {
  x: 151,
  y: 24,
  width: 48,
  height: 48,
  rx: 24,
  fill: "white"
})));

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 280,
    viewBox: "0 0 222 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4983_80110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4983_80110)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4983_80110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 24,
    width: 48,
    height: 48
  }, _ref7), _ref8)), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4983_80110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4983_80110)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4983_80110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 24,
    width: 48,
    height: 48
  }, _ref9), _ref10)), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4983_80110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4983_80110)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4983_80110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 24,
    width: 48,
    height: 48
  }, _ref11), _ref12)), _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3ae9097d97a21c9f0d4fd4d2a876a2bb.svg";
export { ForwardRef as ReactComponent };